<template>
  <v-container fluid class="px-0 pb-2">
    <v-row>
      <v-col cols="auto" class="ms-auto pb-0">
        <slot name="icon"></slot>
      </v-col>
      <v-col cols="auto" class="me-auto pl-0 pb-0">
        <slot name="title"></slot>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
  </v-container>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'DashboardCardTitle',
});
</script>
